import {Injectable} from '@angular/core';
import {map} from "rxjs/operators";

import {SimpleWord} from "../../models/simple-word.model";
import {Observable} from "rxjs";
import {ApiService} from "../api/api.service";
import {SASEUNG3_WORDS_API_URL} from "../../defines/protocol";

export type HanjaWordInfo = {
  hanja: string,
  word_total_count: number,
  words: Array<SimpleWord>,
}


@Injectable({
  providedIn: 'root'
})
export class HanjaService {

  constructor(
    private api: ApiService,
  ) {
  }

  public GetHanjaWordInfo(hanja: string, hangul?: string): Observable<HanjaWordInfo> {
    const url = `${SASEUNG3_WORDS_API_URL}${hanja}/`;
    // 음(hangul)이 있으면 음 기준으로 관련 단어를 필터링하도록 쿼리로 전달한다.
    // 값이 없으면 파라미터 없이 호출하여 기존 동작을 유지한다.
    const params = hangul ? {hangul} : null;
    console.log('HanjaService::GetHanjaWordInfo() url =', url, 'hangul =', hangul);

    return this.api.Get(url, params).pipe(
      map(data => {
        console.log('HanjaService::GetHanjaWordInfo data =', data);
        return {
          hanja: data.hanja,
          word_total_count: data.word_total_count,
          words: data.words.map((word: any) => new SimpleWord(word))
        };
      })
    );
  }
}
